import React from "react";
import BreadCrumb from "../Common/BreadCrumb";

const DashboardInquiry = () => {
  return (
    <div className="p-5">
      <BreadCrumb title="Dashboard Inquiry" trail={["Dashboard", "Inquiry"]} />
    </div>
  );
};

export default DashboardInquiry;
